"use strict";
(function (global) {

  var waitIntervalID = 0;
  var selectedProvider;
  var defaultRealm;
  var jLogin,
    jPassword,
    jRealm,
    jRealmBlock,
    jChangePasswordBlock,
    jChangePasswordLink,
    jWinAuthLogin,
    jChangePasswordLabel,
    jLoginLabel,
    jDefaultRealm,
    jProviders,
    jError,
    jLoginContainer,
    jAdvancedSettingsContainer;


  /**
  * Логика страницы входа веб-доступа
  * @namespace Core.pages
  * @since 5.2.0.1200
  */
  global.login = {

    init: function () {
      InitHoverForButtons();
      RemoveUserStatusCookie();
      log.debug('LOGIN','LoginPage initialization');

      this.initInputsFocus();
      this.initDomObjects();
      this.bindInputHandlers();
      this.onAuthenticationProviderChange($('#ProviderList'));
      this.detectAutomatedTesting();
      log.debug('LOGIN', 'LoginPage initialized');      
    },

    detectAutomatedTesting: () => {
      if (location.search.indexOf('autotest') > 0) {
        localStorage.setItem('autotest', 'true');
      } else {
        localStorage.removeItem('autotest');
      }
    },

    /**
    * Выбираем куда поставить фокус при загрузке. На поле с паролем или на поле
    * с логином.
    */
    initInputsFocus: function () {
      var login = $("#LoginTextBox");
      try {
        if (login.val() != "") {
          $("#PasswordTextBox").focus();
        } else {
          login.focus();
        }
      } catch (ex) {
        //Глушим. 
      };
    },

    /**
    * Закшируем все объекты раз и до конца.
    * @global
    * @function initDomObjects  
    */
    initDomObjects: function () {
      //  jRealmBlock = $("#realmBlock");
      //  //jDefaultRealmBlock = $("#defaultRealmBlock");
      jDefaultRealm = $("#DefaultRealmValue");
      jProviders = $("#ProviderList");
      //  jChangePasswordBlock = $("#changePaswordBlock");
      //  jChangePasswordLink = $('#ChangePasswordLink');    
      //  jWinAuthLogin = $('#WinAuthLogin');
      jLogin = $('#LoginTextBox');
      jPassword = $('#PasswordTextBox');
      jRealm = $("#RealmTextBox");
      jChangePasswordLabel = $('.forchangepwd');
      jLoginLabel = $('.forlogin');
      jAdvancedSettingsContainer = $("#advancedSettingsContainer");
      jError = $('#login_error');
      jLoginContainer = $('#login_container');
    },

    /**
    * Навешиваем обработчки пользовательского ввода
    * @global
    * @function bindInputHandlers
    */
    bindInputHandlers: function () {
      if (jProviders.find("option[value='" + STD_AUTH_PROVIDERS.WINDOWS + "']").length !== 0) {
        jLogin.bind('keypress keyup', this.processUserName);
        if (WA.ENV.isAndroid()) jLogin.bind('change', this.processUserName);
      };
    },

    /**
    * Показать дополнительные параметры
    */
    toggleAdvancedSettings: function (el) {
      if ($(el).hasClass("disabled")) return;
      //$('#advancedSettingsContainer').slideToggle('fast');
      var height = 140;
      $('#advancedSettings').hide('fast');
      
      $('#advancedSettingsContainer').css({ visibility: "visible" }).animate(
        { height: height, opacity: 1.0},
        { duration: 'normal' });
      $('#defaultRealmRow').animate(
        { height: 0, margin: 0,  opacity: 1.0},
        { duration: 'normal' });
    },

    /**
    * Оправка формы по Enter-у
    */
    formSubmit: function (event) {
      try {
        var isLoginDisabled = ($("#LoginTextBox").attr('disabled') == "disabled");
        var charCode = (event.which) ? event.which : window.event.keyCode;
        if (charCode == 13) {
          if (isLoginDisabled) {
            document.getElementById('ChangePasswordButton').onclick();
          } else {
            document.getElementById('LoginButton').onclick();
          }
          return false;
        }
      } catch (e) { };
    },  

    /**
    * Обновляем интерфейс при смене типа аутентификации пользователем.
    */
    onAuthenticationProviderChange: function (el) {
      var type = el.val();
      selectedProvider = type;

      var credentials = g_userCredentials[selectedProvider];
      if (credentials) {
        var loginField = credentials["http://schemas.comp.npo/ws/2015/user/credentials/name"];
        var passwordField = credentials["http://schemas.comp.npo/ws/2015/user/credentials/password"];
        var realmField = credentials["http://schemas.comp.npo/ws/2015/user/credentials/realm"];
        var enteredLogin = $("#LoginTextBox").val();
         

        if (loginField) {
          $("#loginRow").show();
          $("#LoginTextBox").val(enteredLogin);
          $("#loginLabel").text(loginField.caption);
        } else {
          $("#loginRow").hide();
        }

        if (passwordField) {
          $("#passwordRow").show();
          //$("#PasswordTextBox").val('');
          $("#passwordLabel").text(passwordField.caption);
        } else {
          $("#passwordRow").hide();
        }

        if (realmField) {
          $("#defaultRealmRow").show();
          $("#DefaultRealmValue").val(realmField.value);
          $("#defaultRealmLabel").text(realmField.caption);
          defaultRealm = realmField.value;

          $("#realmRow").show();
          $("#RealmTextBox").val(realmField.value);
          $("#realmLabel").text(realmField.caption);
        } else {
          $("#realmRow").hide();
          $("#defaultRealmRow").hide();
        }

        $("#LoginTextBox").attr('disabled', false);
        $("#PasswordTextBox").attr('disabled', false);
        $("#RealmTextBox").attr('disabled', false);
      } else {
        $("#LoginTextBox").attr('disabled', true);
        $("#PasswordTextBox").attr('disabled', true);
        $("#RealmTextBox").attr('disabled', true);

        var authenticatedUserName = $("#AuthenticatedUserName").val();
        if (authenticatedUserName != "") {
          $("#LoginTextBox").val(authenticatedUserName);
          this.showMessageOnLogin(L('THIRD_PARTY_PASSTHROUGH_AUTHENTICATION_CONFIGURED'), MESSAGE_TYPE.INFO);
        }
      }

      if (selectedProvider == STD_AUTH_PROVIDERS.SQL) {
        $("#changePaswordBlock").show();
        $("#ChangePasswordLink").removeClass('hidden');
      } else {
        $("#changePaswordBlock").hide();
        $("#ChangePasswordLink").addClass('hidden');
      }
    },

    /**
    * Отображает сообщение при входе пользователя.
    */
    showLogonMessage: function (msg) {
      $(function () {
        try { $("select").focus(); } catch (ex) { };

        if ($('#modal').length == 0)
          $("form#LoginForm").append("<div id='modal'></div>")

        var $dialog = $("#modal")
                    .html(msg)
                    .dialog({
                      resizable: false,
                      modal: true,
                      autoOpen: true,
                      title: L("INFO"),
                      width: 380,
                      buttons:
                      [
                        {
                          text: L("OK"),
                          click: function () {
                            window.location.reload();
                          }
                        }
                      ]
                    });
      });
      InitMouseEvents();
    },

    /**
    * Отображает сообщение об успешной смене пароля.
    */
    showChangePasswordMessage: function (firstMsg, firstLogin, msg) {
      var me = this;

      //Данный код отображает тултип вместо окна диалога
      //$('#PasswordTextBox').val($('#NewPasswordTextBox').val());
      //HideTopSpinner(L("USER_PASSWORD_WAS_CHANGED_SUCCESSFULLY"), 2000);
      //me.loginUser();
      //me.showLoginForm();
      //return false;

      $(document).ready(function () {
        try { $("select").focus(); } catch (ex) { };

        if ($('#modal').length == 0)
          $("form#LoginForm").append("<div id='modal'></div>")

        var $dialog = $("#modal")
                    .html(msg)
                    .dialog({
                      resizable: false,
                      modal: true,
                      autoOpen: true,
                      title: L("INFO"),
                      width: 360,
                      buttons:
                      [
                        {
                          text: L("OK"),
                          click: function () {
                            if (firstMsg == 'False' && firstLogin == 'True') {
                              $('#LoginUser').attr('disabled', true);
                              var buttonSet = $('.ui-dialog').find('.ui-dialog-buttonset');
                              buttonSet.find('button').attr('disabled', true);
                              buttonSet.prepend('<img style="position:relative;top:3px;" src="/images/spinner.gif" />');
                              $('#PasswordTextBox').val($('#NewPasswordTextBox').val());
                              me.loginUser();
                              me.showLoginForm();
                            } else {
                              if (firstMsg == 'False' && firstLogin == 'False') {
                                $('#PasswordTextBox').val('');
                                $('#NewPasswordTextBox').val('')
                                $('#ConfirmPasswordTextBox').val('')
                                me.showLoginForm();
                              }
                              $(this).dialog("close");
                            }
                          }
                        }
                      ]
                    });
      });
      InitMouseEvents();
    },

    ///**
    //* Поиск информации о домене в имени пользователя
    //* @innner
    //* @function findDomain
    //* @return {object}
    //*/
    //findDomain: function (text, separator) {
    //  var hasDomain = false,
    //    connectionString,
    //    userName,
    //    domain;

    //  if (text.indexOf(separator) !== -1) {
    //    connectionString = text.split(separator);
    //    userName = connectionString[1];
    //    domain = connectionString[0];
    //    hasDomain = true;
    //  };

    //  return {
    //    "hasDomain": hasDomain,
    //    "userName": userName,
    //    "domain": domain
    //  };
    //},

    /**
    * Обработка домена в строке с именем  пользователя
    * @global 
    * @function processUserName
    */
    processUserName: function () {
      var findDomain = function (text, separator) {
        var hasDomain = false,
        connectionString,
        userName,
        domain;

        if (text.indexOf(separator) !== -1) {
          connectionString = text.split(separator);
          userName = connectionString[1];
          domain = connectionString[0];
          hasDomain = true;
        };

        return {
          "hasDomain": hasDomain,
          "userName": userName,
          "domain": domain
        };
      }

      if (selectedProvider == STD_AUTH_PROVIDERS.WINDOWS) {
        var userName = $(this).val();
        var separators = ['\\'];

        for (var separator in separators) {
          var domainInfo = findDomain(userName, separators[separator]);
          if (domainInfo.hasDomain) {
            jDefaultRealm.val(domainInfo.domain);
            jRealm.val(domainInfo.domain);
          } else {
            //Меняем домен на значение по умолчанию, только если текущее значение не было изменено пользователем.
            if (jDefaultRealm.text() == jRealm.val()) {
              jDefaultRealm.val(defaultRealm);
              jRealm.val(defaultRealm);
            }
          }
        }
      }
    },

    /**
    * Отображает сообщение на страница входа пользователя.
    * @global
    * @function showMessageOnLogin  
    */
    showMessageOnLogin: function (msg, type) {
      if (jError.length == 0) {
        jError = $('<div id="login_error" class="login__error">');
        jLoginContainer.append(jError);
      }

      if (msg) {
        jError.html(msg).show();
        if (type == MESSAGE_TYPE.INFO) {
          jError.addClass('login__error_type_notification');
        } else {
          jError.removeClass('login__error_type_notification');
        }
      } else {
        jError.hide().text('');
      }
    },

    /**
    * Скрывает сообщение на страница входа пользователя.
    * @global
    * @function hideMessageOnLogin  
    */
    hideMessageOnLogin: function () {
      this.showMessageOnLogin('');
    },

    /**
    * Если была нажата ссылка "изменить пароль", показываем форму смены пароля.
    * @global
    * @function ShowPasswordChangeForm  
    */
    showPasswordChangeForm: function (firstLogin) {
      jAdvancedSettingsContainer.hide();
      jChangePasswordLabel.removeClass('hidden');
      jLoginLabel.addClass('hidden');
      //Очищаем поле пароля, игнорируем первый вход (т.е. пароль по умолчанию, которого сейчас нет)
      jPassword.val('');
      $("#defaultRealmRow").hide();      
      jLogin.attr('disabled', true);
      jLogin.attr('readonly', true).addClass('react-input__field_disabled');
      //if (firstLogin == 'True') {
      //  jLogin.attr('readonly', true).css('color', '#808080');
      //  jPassword.parent().hide();
      //}
      $('#IsFirstLogin').val(firstLogin);
      $('#login_error').hide();
      return false;
    },

    /**
    * После успешной смены пароля, а также при нажатии на кнопку "Отмена"
    * восстанавливается форма логина.
    * @global
    * @function ShowLoginForm   
    */
    showLoginForm: function () {
      jAdvancedSettingsContainer.show();
      this.hideMessageOnLogin();
      jLoginLabel.not('.novell').removeClass('hidden');
      jChangePasswordLabel.addClass('hidden');        
      jLogin.attr('readonly', false).removeClass('react-input__field_disabled');
      jLogin.attr('disabled', false);
      jPassword.parent().show();
      return false;
    },

    changePassword: function () {
      var me = this;
      $("#ChangePasswordButton").attr('disabled', true).addClass('disabled');

      ChangeUserPassword($("#ProviderList").val(),
        $("#LoginTextBox").val(),
        $("#PasswordTextBox").val(),
        $("#NewPasswordTextBox").val(),
        $("#ConfirmPasswordTextBox").val(),
        $("#IsFirstLogin").val(),
        function (message) {
          $("#ChangePasswordButton").removeAttr('disabled').removeClass('disabled');
          me.hideMessageOnLogin();
          me.showChangePasswordMessage('False', $("#IsFirstLogin").val(), message);
        }, function (message) {
          $("#ChangePasswordButton").removeAttr('disabled').removeClass('disabled');
          me.showMessageOnLogin(message);
        });

      //CallService("/Authentication.asmx/ChangePassword", {
      //  Login: $("#LoginTextBox").val(),
      //  PasswordOld: $("#PasswordTextBox").val(),
      //  PasswordNew: $("#NewPasswordTextBox").val(),
      //  PasswordConfirm: $("#ConfirmPasswordTextBox").val(),
      //  IsFirstLogin: $("#IsFirstLogin").val()
      //}, function (res) {
      //  $("#ChangePasswordButton").removeAttr('disabled').removeClass('disabled');
      //  if (res.Success) {
      //    me.hideMessageOnLogin();
      //    me.showChangePasswordMessage('False', $("#IsFirstLogin").val(), res.Warning);
      //  } else {
      //    me.showMessageOnLogin(res.Error);
      //  }
      //}
      //);
      return false;
    },

    loginUser: function () {
      var me = this;
      clearTimeout(waitIntervalID);
      $("#LoginButton").attr('disabled', true).addClass('disabled');
      waitIntervalID = setTimeout(this.showWait, 800);

      var userRealm = $("#RealmTextBox").val();
      if (userRealm == "")
        userRealm = $("#DefaultRealmLabel").text();

      LoginUser($("#ProviderList").val(), $("#LoginTextBox").val(), userRealm, $("#PasswordTextBox").val(), ($("#RememberMeChk:checked").length == 1),
        function (message) {
          clearTimeout(waitIntervalID);
          me.hideWait();
          $("#LoginButton").removeAttr('disabled').removeClass('disabled');
          me.showPasswordChangeForm('True');
          me.showChangePasswordMessage('True', 'True', message);
        }, function (message) {
          clearTimeout(waitIntervalID);
          me.hideWait();
          $("#LoginButton").removeAttr('disabled').removeClass('disabled');
          me.showLogonMessage(message);
        }, function (message) {
          clearTimeout(waitIntervalID);
          me.hideWait();
          $("#LoginButton").removeAttr('disabled').removeClass('disabled');
          me.showMessageOnLogin(message);
        });
      return false;
    },

    showWait: function () {
      var loginform = $('#login_form');
      loginform.find("input, select, span, label, a").attr('disabled', true).addClass('disabled');
      loginform.find("clearfix.forlogin").hide();
      $('#ChangePwdLink').addClass('disabled');
      loginform.append("<div class='login_wait'><div>" + L("PLEASE_WAIT") + "</div><div class='login__spinner circle-spinner'></div></div>");
      loginform.find(".login_wait").show();
    },

    hideWait: function () {
      var loginform = $('#login_form');
      loginform.find(".login_wait").hide().remove();
      loginform.find(".clearfix.forlogin").show();
      $('#ChangePwdLink').removeClass('disabled');
      loginform.find("input, select, span, label, a").removeAttr('disabled').removeClass('disabled');
    }
  };
})(window.Core.pages)